export const upsertListItem = ({ list, item, matchKey }) => {
  const index = list.findIndex(
    (current) => current[matchKey] === item[matchKey]
  )
  if (index >= 0) {
    list.splice(index, 1, { ...list[index], ...item })
  } else {
    list.push(item)
  }
}
